// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { getUserFullName } from "utils/string";

export const getAuthorName = (message) => {
  if (message.was_autogenerated && !message.author) {
    return "Vewd Moderator";
  }
  if (!message.author) {
    return "Unknown user";
  }
  return getUserFullName(message.author.given_name, message.author.family_name);
};
